module.exports = __webpack_public_path__ + "static/toni-headshot-597e3935a8ce27f611bd89ebf312c9c2.jpg";